import * as React from 'react'
import { useNavigate } from 'react-router-dom'
import ModalActionDialog from 'components/modals/dialogs/modal-action-dialog'

const UpdateError = () => {
  const navigate = useNavigate()
  const onClose = () => navigate('/settings/billing')

  return (
    <ModalActionDialog
      type="error"
      header="Sorry!"
      submitButtonCaption="Ok"
      onSubmit={onClose}
      onClose={onClose}
    >
      Sorry, those payment details weren’t able to be added.
    </ModalActionDialog>
  )
}

export default UpdateError
